import { useConcept } from '../../../redux/selectConcept'

interface L4SelectOptionProps {
	cid?: string,
	subconceptCid?: string,
}

const L4SelectOption = ({subconceptCid}: L4SelectOptionProps) => {
	const subconcept = useConcept(subconceptCid)
	let title = subconcept?.title || subconceptCid
	if(!subconcept) {
		title = `Subconcept '${subconceptCid}' not found`
	}
	return <option value={subconceptCid}>{title}</option>
}

export default L4SelectOption
